<template>
  <div class="con">
    <!-- 无货下架 弹窗-->
    <div v-if="false">
      <van-collapse v-model="activeNames" @change="changeShowItem">
        <van-collapse-item name="1">
          <template #title>
            <div class="col_item clearfix">
              <img
                src="@/assets/product/out_off@2x.png"
                alt=""
                class="left col_icon"
              />
              <div class="left title_left text_left">
                <div
                  class="font14 font_weight600 colo087 line_height_20 title_title"
                >
                  商品已下架
                </div>
                <div
                  class="font12 font_weight400 colo038 line_height_17 title_det"
                >
                  请看看其他商品吧
                </div>
              </div>
            </div>
          </template>
          <div class="product_middle">
            <div v-for="(i, index) in 5" :key="index" class="middle_item">
              <product-ver :showShare="false" />
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>

    <!-- 有货时 -->
    <div
      v-if="!(mallretailspu.status === 0 || mallretailspu.inStock === 0)"
      class="clearfix pad_lr"
    >
      <!-- icon -->
      <div class="left font12 icon_list" @click="clickIcon(0)">
        <img src="@/assets/product/icon_home@2x.png" alt="" class="left_icon" />
        <div class="icon_name font10 font_weight400 colo087 line_height_14">
          首页
        </div>
      </div>
      <div class="left font12 icon_list" @click="clickIcon(index)">
        <pharmacist />
      </div>
      <div class="left font12 icon_list" @click="clickIcon(2)">
        <img src="@/assets/product/icon_cart@2x.png" alt="" class="left_icon" />
        <div class="icon_name font10 font_weight400 colo087 line_height_14">
          购物袋
        </div>
      </div>
      <!-- button -->
      <div
        class="right font14 font_weight500 colof buy_now"
        @click="clickBtn('buyNow')"
      >
        立即购买
      </div>
      <div
        class="right font14 font_weight500  colo087 add_cart"
        @click="clickBtn('addCart')"
      >
        加入购物车
      </div>
    </div>
    <!-- 无货或者下架时 -->
    <div
      v-if="mallretailspu.status === 0 || mallretailspu.inStock === 0"
      class="pad_lr flex_bet"
    >
      <!-- 客服按钮 -->
      <!-- <pharmacist /> -->
      <!-- icon -->
      <div class="left font12 icon_list" @click="clickIcon(0)">
        <img src="@/assets/product/icon_home@2x.png" alt="" class="left_icon" />
        <div class="icon_name font10 font_weight400 colo087 line_height_14">
          首页
        </div>
      </div>
      <div class="left font12 icon_list" @click="clickIcon(index)">
        <pharmacist />
      </div>
      <div class="left font12 icon_list" @click="clickIcon(2)">
        <img src="@/assets/product/icon_cart@2x.png" alt="" class="left_icon" />
        <div class="icon_name font10 font_weight400 colo087 line_height_14">
          购物袋
        </div>
      </div>
      <!-- button -->
      <div class="out_btn font14 font_weight600 colof87">
        {{ mallretailspu.status === 0 ? "已下架" : "暂时缺货" }}
      </div>
    </div>
  </div>
</template>
<script>
const ProductVer = () => import("../../../../home/components/ProductVer");
const Pharmacist = () =>
  import("@/components/Pharmacist").then(m => m.default || m);
export default {
  components: {
    ProductVer,
    Pharmacist
  },
  props: {
    tradeType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      iconList: [
        { iconUrl: require("@/assets/product/icon_home@2x.png"), name: "首页" },
        {
          iconUrl: require("@/assets/product/icon_service@2x.png"),
          name: "客服"
        },
        {
          iconUrl: require("@/assets/product/icon_cart@2x.png"),
          name: "购物袋"
        }
      ],
      show: false,
      activeNames: []
    };
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  methods: {
    isAdd(props) {
      if (props !== null) {
        return !(
          (props.tradeType === 2 &&
            props.kind === 1 &&
            props.isCycle > 0 &&
            props.isCycle !== null) ||
          (props.tradeType === 2 && props.kind === 2)
        );
      }
      return true;
    },
    changeShowItem(a) {
      if (a && a.length) {
        this.show = true;
      } else {
        this.show = false;
      }
      this.$emit("changeShowItem", this.show);
    },
    clickIcon(index) {
      switch (index) {
        case 0:
          this.$router.push("/home");
          break;
        case 1:
          this.$router.push("/home");
          break;
        case 2:
          this.$router.push("/cart");
          break;
      }
    },
    // 立即购买
    buyNow() {
      this.$emit("buyNow");
    },
    clickBtn(value) {
      this.$emit("clickBtn", value);
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  background: #fff;
  box-shadow: 0px -3px 6px -3px rgba(193, 200, 207, 0.4);
  // padding-bottom: 12px;
  .icon_list {
    padding-right: 12px;
    .left_icon {
      width: 24px;
    }
  }
  .buy_now {
    background: linear-gradient(180deg, #e8caa1 0%, #bf9264 100%);
    box-shadow: -1px -1px 4px 0px rgba(255, 255, 255, 0.5);
    border-radius: 21px;
    line-height: 42px;
    padding: 0 23px;
    margin-left: 10px;
  }
  .add_cart {
    border-radius: 21px;
    border: 1px solid #000;
    line-height: 40px;
    padding: 0 14px;
  }
  .mr {
    padding-left: 22px;
  }
  .pad_lr {
    padding: 9px 12px 12px;
    box-shadow: 3px 0px 6px -3px rgba(193, 200, 207, 0.5);
  }
  .flex_bet {
    display: flex;
    justify-content: space-between;
  }
  .out_btn {
    background: rgba(0, 0, 0, 0.25);
    border-radius: 21px;
    line-height: 42px;
    // padding: 0 90px;
    width: 60%;
  }
  ::v-deep .van-cell {
    padding: 11px 12px;
    background: #f1f2f3;
  }
  ::v-deep .van-collapse-item__content {
    padding: 0;
  }
  ::v-deep .van-cell__right-icon {
    color: #000;
    font-weight: 600;
    margin-top: 10px;
  }
}
.product_middle {
  z-index: 100;
  display: flex;
  align-items: center;
  overflow-y: hidden;
  flex-wrap: nowrap;
  padding: 0 12px 16px;
}
.middle_item {
  margin-right: 20px;
  list-style: none;
}

.middle_item > .product {
  width: 100px;
}

.middle_item > .product_name {
  font-size: 10px;
}

.middle_item > .product_price {
  font-size: 10px;
}
.col_item {
  .col_icon {
    width: 54px;
  }
  .title_left {
    margin-left: 12px;
    .title_title {
      margin-top: 7px;
    }
    .title_det {
      margin-top: 4px;
    }
  }
}
</style>
